import FooterPortal from 'containers/Layouts/Layout/FooterPortal'
import ProductGameTile from 'containers/ProductGameTile'
import type { MyGamesPageType } from 'pageContainers/MyGames/Games/types'

import classes from './styles.module.scss'

export const GamesList = (props: MyGamesPageType) => {
  return (
    <>
      <div className={classes.container} data-testid={props.dataTestId}>
        {props.games.map((game, index) => (
          <ProductGameTile game={game} key={game.code} gameIndex={index + 1} showFavorite layout={props.layout} />
        ))}
      </div>
      <FooterPortal />
    </>
  )
}
